import React from 'react'

import { Icon } from '@primer-io/goat'
import styled from 'styled-components'
import { Check, Close } from '@primer-io/goat-icons'

const Root = styled.span`
	${Icon} {
		height: 39px;
		vertical-align: middle;
	}
`


export const YesTableIcon = <Root><Icon as={Check} color='green-700' /></Root>
export const NoTableIcon = <Root><Icon as={Close} color='red-700' /></Root>
